import { Grid, Paper, Typography } from '@mui/material'
import React,{useEffect} from 'react'
import Resumedata from '../../Utilitize/Resumedata'
import Customtimeline, { CustomeTimelineseparator } from '../../Components/Timeline/Mytimeline.js'
import WorkIcon from '@mui/icons-material/Work';
import './Resume.css'
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineDot from '@mui/lab/TimelineDot';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import HistoryEduIcon from '@mui/icons-material/HistoryEdu';
import CardMembershipIcon from '@mui/icons-material/CardMembership';
import Aos from 'aos'
import 'aos/dist/aos.css'
import './Resume.css'
function Resume() {

   useEffect(()=>{
      Aos.init();
   },[])
    return (
        <>
        <title>Home | resume</title>
         {/* about me */}
         <Grid container className="section" style={{paddingTop:"30px"}}>
            <Grid item  className="section_title mb-4">
               <span></span>
               <h6 className="section_title_text">About me</h6>  
            </Grid>

            <Grid item xs={12} className="section_title">
              
               <Typography variant="body2" className="aboutme_text">{Resumedata.about}</Typography>  
            </Grid>
         </Grid>
          {/* education and experience */}
         <Grid container className="section">
             <Grid item  className="section_title mb-4">
               <span></span>
               <h6 className="section_title_text">Resume</h6>  
            </Grid>

            <Grid item xs={12}>
               <Grid container>
                  {/* projects */}
                   <Grid item sm={12} md={6}>
                       <Customtimeline title="My Projects" icon={<WorkIcon/>} >
                       {
                          Resumedata.projects.map((project)=>{
                             return(
                              <TimelineItem data-aos="flip-left" data-aos-delay="100">
                                 <CustomeTimelineseparator/>
                                 <TimelineContent>
                                    <Typography className="timeline_title" style={{fontSize:"20px",fontWeight:"bold"}}>{project.projectname}</Typography>
                                    <a href={project.projecturl} target="_blank">{project.projectname} Project url</a>
                                    <ul>
                                       {
                                          project.projectdetails.map((detail)=>{
                                             return(
                                                <li style={{textAlign:"justify"}}>{detail}</li>
                                             )
                                          })
                                       }
                                    </ul>
                                 </TimelineContent>
                             </TimelineItem>
                             )
                          })
                       }
                      </Customtimeline>
                   </Grid>
                  {/* education */}
                   <Grid item sm={12} md={6}>
                   <Customtimeline title="Education history" icon={<HistoryEduIcon/>}>
                       {
                          Resumedata.education.map((deg)=>{
                             return(
                              <TimelineItem data-aos="flip-left" data-aos-delay="100">
                                 <CustomeTimelineseparator/>
                                 <TimelineContent>
                                    <Typography className="timeline_title" style={{fontSize:"20px",fontWeight:"bold"}}>{deg.degree}</Typography>
                                    <Typography className="">{deg.institute}</Typography>
                                    
                                    
                                 </TimelineContent>
                             </TimelineItem>
                             )
                          })
                       }
                      </Customtimeline>




                      <Customtimeline title="ADDITIONAL CERTIFIED" icon={<CardMembershipIcon/>}>
                       {
                          Resumedata.additionalcertificate.map((additional)=>{
                             return(
                              <TimelineItem data-aos="fade-up" data-aos-anchor-placement="top-center">
                                 <CustomeTimelineseparator/>
                                 <TimelineContent>
                                    <Typography className="timeline_title" style={{fontSize:"20px",fontWeight:"bold"}}>{additional.course}</Typography>
                                    <Typography className="">{additional.institute}</Typography>
                                    
                                    
                                 </TimelineContent>
                             </TimelineItem>
                             )
                          })
                       }
                      </Customtimeline>
                   </Grid>
               </Grid>
            </Grid>
         </Grid>
         {/* Skills */}
         <Grid container  className="section graybg" style={{paddingBottom:"45px",padding:"50px"}}>
            <Grid item xs={12}>
                  <Grid container>
                     <Grid item  className="section_title mb-4">
                       <span></span>
                       <h6 className="section_title_text">Skills</h6>  
                     </Grid>
                  </Grid>
               <Grid container spacing={3} justifyContent="space-between">
               {
                  Resumedata.skills.map((skill)=>{
                    return(<Grid item xs={12} sm={6} md={3} data-aos="fade-up" data-aos-anchor-placement="top-center">
                           <Paper elevation={0} className="skill">
                              <Typography variant="h6" className="skills_title">
                                 {skill.title}
                              </Typography>
                              {
                                 skill.description.map((element)=>{
                                    return(
                                       <Typography variant="body2" className="skill_description">
                                          <TimelineDot variant={'outlined'} className="timeline_dot"/>
                                          {element}
                                       </Typography>
                                    )
                                 })
                              }
                           </Paper>
                       </Grid>)
              })
           }
               </Grid>
            </Grid>
           
         </Grid>

        
        </>
    )
}

export default Resume
